import arrow from "../media/arrow2.png"

export function HeaderButton(props: {click: any, className: string, name: string, showArror?: boolean, 
        color1: string, color2: string, id?: any, shown?: boolean}) {
    const toBeShown = props.shown ? props.shown : false 
    return <div onClick={props.click} id={props.id} key={props.id}
        className={"uppercase flex items-center transform transition-all delay-0"+
            (" hover:text-"+props.color1+" text-white ") +
            props.className} >
            {props.showArror ? 
                <img src={arrow} className={"transform rotate-45 "+(toBeShown ? "" : " invisible ")}/>
            : <></>} 
            {props.name}</div>
}

export function DexxTableTitle(props: {label: string, active: boolean, dark?: boolean,
        className?: string, onClick?: Function}): JSX.Element {
    return <>
        <div className={"uppercase py-5 flex items-center "+
            " font-normal text-xs md:text-base cursor-pointer "+
            (props.active ? " bg-white_light text-dark_blue " : (" text-white ")+
            (props.dark ? " bg-dark_blue_lighter " : " "))
            +props.className}
            onClick={() => {if(props.onClick) props.onClick()}}
        >   
            {props.label}</div>
    </>
}